import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BamTransferServiceService {

  private URL = environment.api + "api/bamtransaction";

  constructor(
      private http: HttpClient
    ) { }

  sendTransfer(request: any) {
    return this.http.post(`${this.URL}/transfers`, request);
  }

  sendPayroll(request: any) {
    return this.http.post(`${this.URL}/payroll-transfers`, request);
  }

  sendTaxPaymentTransfer(request: any){
    return this.http.post(`${this.URL}/tax-payment-transfers`, request);
  }
  
  sendCreditCardPayment(request: any){
    return this.http.post(`${this.URL}/credit-card-transfers`, request);
  }

  sendLoanPayment(request: any){
    return this.http.post(`${this.URL}/loan-payment-transfers`, request);
  }

  sendInternationalTransfer(request: any){
    return this.http.post(`${this.URL}/international-transfers`, request);
  }

  postLoadFavorite(request: any){
    return this.http.post(`${this.URL}/loads/favorites`, request);
  }

  getHistory(startDate: string, endDate: string) {
    return this.http.get(`${this.URL}/history/${startDate}/${endDate}`)
  }

  getFavoriteHistory(startDate: string, endDate: string) {
    return this.http.get(`${this.URL}/history/favorites/${startDate}/${endDate}`)
  }

  getBatchId(batchId: any){
    return this.http.get(`${this.URL}/batch/${batchId}`);
  }

  getFavoriteBatchId(batchId: any){
    return this.http.get(`${this.URL}/batch/favorites/${batchId}`);
  }

  getAccountMovement(data: any) {
    return this.http.post(`${this.URL}/query/account-movements`, data);
  }

  getAccountStatus(data: any) {
    return this.http.post(`${this.URL}/query/account-status`, data);
  }

  getReceipts(data: any) {
    return this.http.post(`${this.URL}/query/receipts`, data, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  getVoucher(data: any) {
    return this.http.post(`${this.URL}/query/vouchers`, data, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  getAccountMovementMT940(data: any) {
    return this.http.post(`${this.URL}/query/movements-mt940`, data);
  }
}
